import React from 'react';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import { useMediaConfigGame } from 'bdvp-common/src/hooks/config';
import NotificationContainer from 'bdvp-common/src/containers/Notification';
import NotificationRenderer from 'bdvp-common/src/components/NotificationRenderer';

export const NotificationComponent = styled(NotificationContainer)`
    margin: ${({ theme }) => `20px ${theme.pageTemplate.paddingLeftRight.xs} 0px ${theme.pageTemplate.paddingLeftRight.xs}`};

    ${media.mdmin`
        margin: ${({ theme }) => `25px ${theme.pageTemplate.paddingLeftRight.md} 0px ${theme.pageTemplate.paddingLeftRight.md}`};
    `}

    ${media.lgmin`
        margin: ${({ theme }) => `25px ${theme.pageTemplate.paddingLeftRight.lg} 0px ${theme.pageTemplate.paddingLeftRight.lg}`};
    `}
`;

export const renderNotification =  (id, contentConfig) => (
    <NotificationComponent id={id} contentConfig={contentConfig} />
);

const Notification = () => {

    const config = useMediaConfigGame();

    return (
        <NotificationRenderer
            config={config}
            render={renderNotification}
        />
    );

};

export default Notification;
